import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=00b8c098&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=00b8c098&prod&lang=less"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=00b8c098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8c098",
  null
  
)

export default component.exports